module.exports = __webpack_public_path__ + "static/media/IMO.81a82d21.svg";


//////////////////
// WEBPACK FOOTER
// ./src/wbstdt/imgs/normes/IMO.svg
// module id = 65
// module chunks = 0